import { sendAnalyticsInfo } from 'features/analytics/helpers';
import type { ConnectionChangeType } from 'features/call/call-base/enums';
import { CallStatusLogMessages } from 'features/call/call-status/enums';

export const deafDisconnectAnalytics = (
  methodName: string,
  connectionChangeType?: ConnectionChangeType
) => {
  return sendAnalyticsInfo({
    Method: methodName,
    Message: CallStatusLogMessages.DEAF_LEG_DISCONNECTED,
    DisconnectedBy: connectionChangeType,
    DeafParticipantStatus: 'disconnected',
  });
};

export const deafConnectedAnalytics = (
  methodName: string,
  deafPhoneNumber: string
) => {
  return sendAnalyticsInfo({
    Method: methodName,
    Message: CallStatusLogMessages.DEAF_LEG_CONNECTED,
    DeafParticipantStatus: 'connected',
    DeafPhoneNumber: deafPhoneNumber,
  });
};

export const deafConnectingAnalytics = (methodName: string) => {
  return sendAnalyticsInfo({
    Method: methodName,
    Message: CallStatusLogMessages.DEAF_LEG_CONNECTING,
    DeafParticipantStatus: 'connecting',
  });
};

export const deafUnavailableAnalytics = (methodName: string) => {
  return sendAnalyticsInfo({
    Method: methodName,
    Message: CallStatusLogMessages.DEAF_LEG_UNAVAILABLE,
    DeafParticipantStatus: 'unavailable',
  });
};

export const hearingConnectingAnalytics = (
  methodName: string,
  phoneNumber: string
) => {
  return sendAnalyticsInfo({
    Method: methodName,
    HearingParticipantStatus: 'connecting',
    Message: CallStatusLogMessages.HEARING_PARTICIPANT_CONNECTING,
    HearingPhoneNumber: phoneNumber,
  });
};

export const hearingConnectedAnalytics = (
  methodName: string,
  phoneNumber: string
) => {
  return sendAnalyticsInfo({
    Method: methodName,
    HearingParticipantStatus: 'connected',
    Message: CallStatusLogMessages.HEARING_PARTICIPANT_CONNECTED,
    HearingPhoneNumber: phoneNumber,
  });
};

export const hearingDisconnectedAnalytics = (
  methodName: string,
  phoneNumber: string
) => {
  return sendAnalyticsInfo({
    Method: methodName,
    HearingParticipantStatus: 'disconnected',
    Message: CallStatusLogMessages.HEARING_PARTICIPANT_DISCONNECTED,
    HearingPhoneNumber: phoneNumber,
  });
};
